import { ca } from '@cian/analytics';
import { EServiceId } from '../../redux/reducers';
import { IAnalyticsProduct, TAnalyticsOfferStatus, TAnalyticsSiteType } from '../../types/analytics';

interface ITrackPublishClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
  totalPrice: number;
  currentBet: number;
  selectedServiceId: EServiceId;
  offerPosition: number | null;
  page: number | null;
  isAutoprolong: boolean;
  formId: string;
}

export const trackPublishClick = (params: ITrackPublishClickParams) => {
  const {
    analyticsOfferStatus,
    analyticsProduct,
    totalPrice,
    currentBet,
    selectedServiceId,
    offerPosition,
    page,
    isAutoprolong,
    formId,
  } = params;

  const isPaid = !!totalPrice;
  const publishType = analyticsOfferStatus === 'New_ad' ? 'place' : 'save';
  const payType = isPaid ? 'pay' : null;
  const publishLabel = [publishType, payType].filter(Boolean).join('&');

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: publishLabel,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        publication_price: totalPrice,
        bid: currentBet,
        vas: selectedServiceId,
        position: offerPosition,
        page_number: page,
        autoprolong: Number(isAutoprolong),
        form_id: formId,
      },
    },
  });
};

export const trackPayByCardModalOpen = (analyticsOfferStatus: TAnalyticsOfferStatus) => {
  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'not_enough_money_popup_open',
    label: 'add_offer',
  });
};

interface ITrackPublishByMoneyFailedParams {
  offerId: number | null;
  isShortForm: boolean;
  siteType: TAnalyticsSiteType;
  analyticsOfferStatus: TAnalyticsOfferStatus;
}

export const trackPublishByMoneyFailed = (params: ITrackPublishByMoneyFailedParams) => {
  const { offerId, isShortForm, siteType, analyticsOfferStatus } = params;

  ca('eventSite', {
    name: 'oldEvent',
    category: analyticsOfferStatus,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'not_enough_money',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        form_type: isShortForm ? 'short' : 'full',
      },
    },
  });
};
